import { z } from 'zod'
import { type Expand } from '@/types/ui/expand'

// Define the client form schema - this is the single source of truth
export const clientFormSchema = z.object({
  selectedClient: z.number().min(1, 'Field is required'),
  selectedContact: z.number().min(1, 'Field is required'),
})

// Automatically infer the TypeScript type from the schema
export type ClientFormData = Expand<z.infer<typeof clientFormSchema>> 